import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { hasAnyOpenClaims } from '../api/claims/claim.api';

/** The read of whether an account has open claims, as a query definition so a hook and a plain fetch share one cache entry. */
export const hasOpenClaimsQuery = (accountId?: string) => ({
  queryKey: ['hasAnyOpenClaims', accountId],
  queryFn: () =>
    hasAnyOpenClaims({ params: { accountId: accountId as string } }).then(
      (res) => Boolean(res.data)
    ),
  staleTime: 60000,
});

export const useHasOpenClaims = (
  accountId?: string,
  options?: Omit<UseQueryOptions<boolean>, 'queryKey' | 'queryFn'>
) =>
  useQuery({
    ...hasOpenClaimsQuery(accountId),
    ...options,
    enabled: Boolean(accountId) && (options?.enabled ?? true),
  });
